<script setup lang="ts">
import type { Enterprise } from '~~/src/types/enterprise'

interface IProps {
  enterprise: Enterprise
  isActive?: boolean
}

const props = defineProps<IProps>()
</script>

<template>
  <div
    flex
    justify-between
    p3
    cursor-pointer
    :class="{ 'bg-primary-light': isActive }"
  >
    <div flex items-center gap-2>
      <img :src="props.enterprise.avatar" w="32px" rounded-full>
      <Text :font-weight="500">
        {{ props.enterprise.name }}
      </Text>
    </div>
    <AppButton v-if="!isActive" variant="outline">
      Select
    </AppButton>
  </div>
</template>
